// @flow

import * as React from 'react';
import classNames from 'classnames';
import useSheet from '../../jss';

type Props = {
  children?: any,
  classes: Object,
  className?: string,
  style?: Object
};

const defaultProps = {
  children: undefined,
  className: undefined,
  style: undefined
};

function Grid({ children, classes, className, style }: Props) {
  return (
    <div className={classNames(classes.grid, className)} style={style}>
      {children}
    </div>
  );
}

Grid.defaultProps = defaultProps;

function applyStyles(theme) {
  return {
    grid: {
      display: 'flex',
      flexWrap: 'wrap',
      [theme.mediaQuery.desktopAndUp]: {
        marginLeft: -theme.grid.gutter / 2,
        marginRight: -theme.grid.gutter / 2
      }
    }
  };
}

export default useSheet(applyStyles)(Grid);
